import { useTranslate } from '@growtherapy/i18n';

import { ChatDrawerButtonWrapper as ChatDrawerButton } from '../../chat/ChatDrawerButtonWrapper';
import { MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';

export function VisitorMeetingChatDrawerButton() {
  const t = useTranslate();
  return (
    <ChatDrawerButton
      defaultTitle={t('telehealth-core:meta.meetingRoom')}
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}
